import { combineReducers } from "redux";
import auth from "../../services/authorization/slices";
import { configureStore } from "@reduxjs/toolkit";
import { createAmplifyMiddleware } from "../middleware/hub";
import { storageApi } from "../../services/storage/api";
import { questionsSlice } from "../../services/storage/slices";
import formsSlice from "../../services/form/slices";
import submissionPeriodSlice from "../../services/submissionPeriod/slices";
import { formApi } from "../../services/form/api";
import { sessionApi } from "../../services/submissionPeriod/api";
import { shared } from "../../services/shared/api";
import alertSlice from "../../services/alert/slices";
import { createCacheMiddleware } from "../middleware/cache";

const rootReducer = combineReducers({
  authentication: auth,
  [storageApi.reducerPath]: storageApi.reducer,
  [questionsSlice.reducerPath]: questionsSlice.reducer,
  [submissionPeriodSlice.reducerPath]: submissionPeriodSlice.reducer,
  [formsSlice.reducerPath]: formsSlice.reducer,
  [formApi.reducerPath]: formApi.reducer,
  [sessionApi.reducerPath]: sessionApi.reducer,
  [shared.reducerPath]: shared.reducer,
  [alertSlice.reducerPath]: alertSlice.reducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      createAmplifyMiddleware,
      createCacheMiddleware,
      storageApi.middleware,
      sessionApi.middleware,
      formApi.middleware,
      shared.middleware,
    ),
});


export default store